const reviews = [
    {
        name: "Carol Silva",
        image: "/users/user-img-1.png",
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        rating: 4,
        tour: "Beautiful Holland",
    },
    {
        name: "James Fisher",
        image: "/users/user-img-2.png",
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        rating: 5,
        tour: "Barcelona",
    },
    {
        name: "Kaohsiung",
        image: "/users/user-img-3.png",
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        rating: 5,
        tour: "Roget Brooks",
    },
    {
        name: "Susan Day",
        image: "/users/user-img-4.png",
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        rating: 5,
        tour: "Taipei",
    },
    {
        name: "Carl Moore",
        image: "/users/user-img-5.png",
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        rating: 4,
        tour: "Temple Tour",
    },
    {
        name: "Sam Smith",
        image: "/users/user-img-6.png",
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        rating: 5,
        tour: "Madrid",
    },
    {
        name: "Ema Cooper",
        image: "/users/user-img-7.png",
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        rating: 5,
        tour: "Hollands Canals",
    },
    
]

export default reviews